export default "__VITE_ASSET__CoRsuKNS__"